"use client";
import { useEffect } from "react";
import { configureGTGuard } from "./lib/gt-monkey-patch";
import { setTranslateDetectionDisabled } from "@utils/detect-translator";

// google_translate_disabled resolved to "disable-all" and the flag is gone:
// Google Translate stays locked and the DOM guard (gt-monkey-patch) never runs.
export default function GTGuard() {
    useEffect(() => {
        configureGTGuard({ disableGuard: true, lockTranslate: true });
        setTranslateDetectionDisabled(true);
    }, []);

    return null;
}
